
import './App.css';
import Profile from './portfolio_pages/home/Profile';


function App() {
  return (
    <div className="App">
      <Profile/>
    </div>
  );
}

export default App;
